import React, { FC } from 'react';
import { IConfig } from '../../types/config';

import { IHero1 } from './Hero_1/params';
import { IHero2 } from './Hero_2/params';
import { IHero3 } from './Hero_3/params';

import Hero1 from './Hero_1';
import Hero2 from './Hero_2';
import Hero3 from './Hero_3';

const Hero: FC<{ config: IConfig }> = ({ config }) => {
  const siteNameAlias = config.general.siteNameAlias || config.general.siteName;

  switch (config.home.hero.variant) {
    case 3:
    case '3':
      return <Hero3 config={config.home.hero.params as IHero3} siteNameAlias={siteNameAlias} />;
    case 2:
    case '2':
      return <Hero2 config={config.home.hero.params as IHero2} siteNameAlias={siteNameAlias} />;
    default:
      return <Hero1 config={config.home.hero.params as IHero1} />;
  }
};

export default Hero;
